export const SECO_BASE_PALETTE = [
  '#006cea', '#ffb000', '#ff0000', '#ff8c41', '#00b464', '#b0b0b0',
  '#800080' 
] as const;

export const SECO_TINT_70_PALETTE = [
  '#4d98f0', '#ffc84d', '#ff4d4d', '#ffaf7a', '#4dcb93', '#c8c8c8',
  '#b34db3' 
] as const;

export const SECO_TINT_20_PALETTE = [
  '#cce2fb', '#ffefcc', '#ffcccc', '#ffe8d9', '#ccf0e0', '#efefef',
  '#e6d7e3' 
] as const;

export const SECO_FULL_PALETTE = [
  ...SECO_BASE_PALETTE,
  ...SECO_TINT_70_PALETTE,
  ...SECO_TINT_20_PALETTE
] as const;

export const SECO_BLUE = SECO_BASE_PALETTE[0];
export const SECO_BLUE_TINT_70 = SECO_TINT_70_PALETTE[0];
export const SECO_BLUE_TINT_20 = SECO_TINT_20_PALETTE[0];

export const SECO_PURPLE = SECO_BASE_PALETTE[6];
export const SECO_PURPLE_TINT_70 = SECO_TINT_70_PALETTE[6];
export const SECO_PURPLE_TINT_20 = SECO_TINT_20_PALETTE[6];

const SECO_TONE_FAMILIES = [
  SECO_BASE_PALETTE,
  SECO_TINT_70_PALETTE,
  SECO_TINT_20_PALETTE
] as const;

export const getSecoCategoryColor = (index: number, toneOffset = 0): string => {
  const safeIndex = Number.isFinite(index) ? Math.max(0, Math.floor(index)) : 0;
  const familyIndex = safeIndex % SECO_BASE_PALETTE.length;
  const toneIndex =
    (Math.floor(safeIndex / SECO_BASE_PALETTE.length) + toneOffset) %
    SECO_TONE_FAMILIES.length;

  return SECO_TONE_FAMILIES[toneIndex][familyIndex];
};